<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">Overview</h2>
  </div>

  <p class="wz-lead">A guided path from your Azgaar map to a living world, with its wiki ready to grow.</p>

  <div class="wz-card ov-worksheet">
    <div>
      <p class="wz-card-title">Plan it on paper first</p>
      <p class="wz-muted">A printable worksheet to help you organise your thoughts.</p>
    </div>
    <button type="button" class="btn btn-dark" (click)="openWorksheet()">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v11"/><path d="M7.5 10.5 12 15l4.5-4.5"/><path d="M5 19h14"/></svg>
      Worksheet
    </button>
  </div>

  <div class="wz-card">
    <p class="wz-card-title">The steps</p>
    <ol class="ov-steps">
      <li class="is-core"><span>Upload &amp; validate map files</span></li>
      <li class="is-core"><span>World identity</span></li>
      <li class="is-core"><span>Resource distribution</span></li>
      <li class="is-core"><span>AI involvement level</span></li>
      <li><span>Global context</span></li>
      <li><span>Cultures</span></li>
      <li><span>Religions</span></li>
      <li><span>States</span></li>
      <li><span>Provinces</span></li>
      <li class="is-core"><span>Review and generate</span></li>
    </ol>
    <p class="ov-legend">
      <span class="ov-dot is-core"></span> Every world
      <span class="ov-dot"></span> Depends on how much AI you choose
    </p>
  </div>

  <p class="wz-lead">
    On the last step WorldTumbler generates your world and creates its wiki. With AI involvement, the wizard fills in
    the details from your choices.
  </p>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>
</div>
